let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l1iwu")).then(() => parcelRequire('49aS0'));